/* Foberry customizer - fit pictures.
   No page navigation: Add To Bag stays on the theme's normal AJAX flow (animation + cart drawer).
   If window.LG_UPLOAD_URL is set, each picture is uploaded the moment it is chosen and only its link travels with the order
   (the server stores the file in Shopify Files). If it is empty, the files are sent with the form as before. */
(function () {
  if (window.__lgPics) return;
  window.__lgPics = true;
  var Q = String.fromCharCode(34);
  var NAMES = { front: 'Front', side: 'Side', back: 'Back', other: 'Other' };
  var inflight = 0;

  function endpoint() { return window.LG_UPLOAD_URL || ''; }
  function formId() {
    var b = document.querySelector('.add-to-cart'), f = b && b.closest('form');
    if (f && !f.id) f.id = 'lg-product-form';
    return f ? f.id : '';
  }
  function urlInput(k) { return document.querySelector('input[data-lg-url=' + Q + k + Q + ']'); }
  function setUrl(k, val) {
    var el = urlInput(k);
    if (!val) { if (el && el.parentNode) el.parentNode.removeChild(el); return; }
    if (!el) {
      el = document.createElement('input');
      el.type = 'hidden';
      el.name = 'properties[Fit picture - ' + NAMES[k] + ']';
      el.setAttribute('data-lg-url', k);
      document.body.appendChild(el);
    }
    var id = formId();
    if (id) el.setAttribute('form', id);
    el.value = val;
  }
  function slotOf(k) { return document.querySelector('.lg-slot[data-k=' + Q + k + Q + ']'); }
  function say(k, t) {
    var s = slotOf(k), e = s && s.querySelector('.err');
    if (e) e.textContent = t || '';
  }
  function clearAllUrls() {
    Object.keys(NAMES).forEach(function (k) { setUrl(k, ''); });
  }

  function upload(k, f) {
    inflight++;
    say(k, 'Uploading...');
    var fd = new FormData();
    fd.append('file', f, f.name);
    fd.append('slot', k);
    fetch(endpoint(), { method: 'POST', body: fd })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (!j || !j.url) throw new Error('bad response');
        setUrl(k, j.url);
        say(k, '');
      })
      .catch(function () {
        setUrl(k, '');
        var i = document.querySelector('input[data-lg-f=' + Q + k + Q + ']');
        if (i) { i.value = ''; i.dispatchEvent(new Event('change', { bubbles: true })); }
        say(k, 'Upload failed - please try again');
      })
      .then(function () { inflight = Math.max(0, inflight - 1); });
  }

  /* picture chosen / removed */
  document.addEventListener('change', function (e) {
    var inp = e.target;
    if (!inp || !inp.matches || !inp.matches('input[type=file][data-lg-f]')) return;
    if (!endpoint()) return;
    var k = inp.getAttribute('data-lg-f'), f = inp.files && inp.files[0];
    setUrl(k, '');
    if (!f) return;
    inp.name = '';
    upload(k, f);
  }, true);

  window.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    /* remove button on a slot */
    var rm = t.closest('.lg-slot .rm');
    if (rm) { setUrl(rm.closest('.lg-slot').getAttribute('data-k'), ''); return; }
    /* start again clears every stored link */
    if (t.closest('.start-button')) { clearAllUrls(); return; }
    /* Add To Bag: wait for pictures that are still uploading */
    var b = t.closest('.add-to-cart');
    if (b) {
      var id = formId();
      Object.keys(NAMES).forEach(function (k) { var el = urlInput(k); if (el && id) el.setAttribute('form', id); });
      if (inflight > 0) {
        e.preventDefault();
        e.stopImmediatePropagation();
        b.classList.add('lg-busy');
        var iv = setInterval(function () {
          if (inflight === 0) { clearInterval(iv); b.classList.remove('lg-busy'); b.click(); }
        }, 300);
      }
    }
  }, true);

  document.addEventListener('cart:update', function (e) {
    var d = e && e.detail && e.detail.data;
    if (d && d.source === 'custom-script') setTimeout(clearAllUrls, 900);
  });
})();
